import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, setToken } from "../../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Errore di accesso");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center bg-[#F9FAFB] px-4">
      <div className="w-full max-w-md bg-white border border-[#E5E7EB] rounded-3xl p-8 md:p-10">
        <Link to="/" className="inline-block mb-6">
          <img src="/assets/logo-betelgez.png" alt="Betelgez" className="h-16" />
        </Link>
        <div className="flex items-center gap-2 text-sm text-[#007A3D] font-medium"><Lock className="w-4 h-4" /> Area Riservata</div>
        <h1 className="mt-2 font-display font-black tracking-tighter text-3xl text-[#1A1A1A]">Accedi al CMS</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" data-testid="admin-login-email"
            className="w-full rounded-xl border border-[#E5E7EB] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EAF8F0] focus:border-[#00A651]" />
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" data-testid="admin-login-password"
            className="w-full rounded-xl border border-[#E5E7EB] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EAF8F0] focus:border-[#00A651]" />
          {err && <div className="text-sm text-red-600">{err}</div>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-[#00A651] hover:bg-[#007A3D] text-white rounded-full py-3.5 font-medium disabled:opacity-60">
            {loading ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
